import React from "react";
import { Navigate } from "react-router-dom";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      turnstileToken: "",
      loggedIn: false,
      errorMessage: "",
    };

    this.realusername = "rasmus.schilder@gmx.de";
    this.realpassword = "zywmUh-wojsys-supry3";

    // Globale Callbacks für Cloudflare Turnstile
    window.onTurnstileSuccess = (token) => {
      this.setState({ turnstileToken: token, errorMessage: "" });
    };

    window.onTurnstileExpired = () => {
      this.setState({ turnstileToken: "", errorMessage: "Sicherheitsprüfung abgelaufen – bitte erneut versuchen." });
    };
  }

  // Automatische Sitekey-Umschaltung (lokal vs. Produktion)
  getTurnstileSitekey = () => {
    const isDev =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1" ||
      window.location.port === "3000" ||
      window.location.port === "5173"; // falls Vite

    return isDev
      ? "1x00000000000000000000AA"                  // Testkey → immer erfolgreich
      : "0x4AAAAAACB1wZ-rh6LsQ7lR";                  // Ihr echter Sitekey
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  checklogin = () => {
    const { username, password, turnstileToken } = this.state;

    if (!turnstileToken) {
      this.setState({ errorMessage: "Bitte absolvieren Sie die Sicherheitsprüfung." });
      return;
    }
    if (!username) {
      this.setState({ errorMessage: "Bitte geben Sie einen Benutzernamen ein." });
      return;
    }
    if (!password) {
      this.setState({ errorMessage: "Bitte geben Sie ein Passwort ein." });
      return;
    }
    if (username !== this.realusername || password !== this.realpassword) {
      this.setState({ errorMessage: "Benutzername oder Passwort falsch." });
      window.turnstile?.reset();
      return;
    }

    sessionStorage.setItem("loggedIn", "true");
    this.setState({ loggedIn: true });
  };

  componentDidMount() {
    // Turnstile-Script nur einmal laden
    if (!document.querySelector('script[src*="challenges.cloudflare.com"]')) {
      const script = document.createElement("script");
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  }

  render() {
    if (this.state.loggedIn) {
      return <Navigate to="/loginbort" replace />;
    }

    return (
      <React.Fragment>

        {/* Split-Screen Login Card */}
        <div className="loginBord">
          {/* Linke Seite: Formular */}
          <div className="login-left">
            <h2>Login</h2>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.checklogin();
              }}
            >
              <label>Username</label>
              <input
                type="text"
                name="username"
                value={this.state.username}
                onChange={this.handleChange}
                autoComplete="username"
                placeholder="E-Mail oder Benutzername"
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    this.passwordInput && this.passwordInput.focus();
                  }
                }}
              />

              <label>Password</label>
              <input
                type="password"
                name="password"
                value={this.state.password}
                onChange={this.handleChange}
                autoComplete="current-password"
                placeholder="Passwort"
                ref={(input) => (this.passwordInput = input)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    this.checklogin();
                  }
                }}
              />

              {/* Cloudflare Turnstile – automatisch localhost-kompatibel */}
              <div
                className="cf-turnstile"
                data-sitekey={this.getTurnstileSitekey()}
                data-callback="onTurnstileSuccess"
                data-expired-callback="onTurnstileExpired"
                data-theme="dark"
              ></div>

              {this.state.errorMessage && (
                <div className="error-message">{"•"+this.state.errorMessage}</div>
              )}
              <button type="submit">Login</button>

            </form>
          </div>

          {/* Rechte Seite: Welcome-Text */}
          <div className="login-right">
            <div className="welcome-text">
              Willkommen
            </div>
            <div className="welcome-subtext">
             Schön sie wieder zu sehen,<br />
              Melden Sie sich an, um fortzufahren.
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Login;